import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { N0DES_API_PREFIX } from "@/api/domain"
import type { Deploy, RegionName } from "@/infra"
import type { Checkout } from "@/repos"
import type { Pagination, ProjectIdParam, Uuid } from "@/types"

export type NodeGetParams = ProjectIdParam & {
  deploy_id: Uuid
}

export type NodePostParams = ProjectIdParam & {
  region: RegionName
  size: number
}

export type NodePutParams = ProjectIdParam & {
  deploy_id: Uuid
  checkout: Checkout
}

export const nodesApi = createApi({
  reducerPath: "nodesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${N0DES_API_PREFIX}nodes`,
    mode: "cors",
    credentials: "include",
  }),
  endpoints: (build) => ({
    nodesGet: build.query<Deploy[], ProjectIdParam & Pagination>({
      query: ({ project_id, offset, limit }) => ({
        url: `${project_id}?offset=${offset}&limit=${limit}`,
      }),
    }),
    nodeGet: build.query<Deploy, NodeGetParams>({
      query: ({ project_id, deploy_id }) => ({
        url: `${project_id}/${deploy_id}`,
      }),
    }),
    // provision a new instance
    nodePost: build.mutation<void, NodePostParams>({
      query: (body) => ({
        url: body.project_id,
        method: "POST",
        body,
      }),
    }),
    nodePut: build.mutation<void, NodePutParams>({
      query: (body) => ({
        url: `${body.project_id}/${body.deploy_id}`,
        method: "PUT",
        body,
      }),
    }),
    nodeDelete: build.mutation<void, NodeGetParams>({
      query: ({ project_id, deploy_id }) => ({
        url: `${project_id}/${deploy_id}`,
        method: "DELETE",
      }),
    }),
  }),
})

export const {
  useNodesGetQuery,
  useNodeGetQuery,
  useNodePutMutation,
  useNodeDeleteMutation,
  useNodePostMutation,
} = nodesApi
